import React, { Suspense } from 'react';
import './App.css';
import { useRoutes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { routes } from './routes';
import GlobalMessage from './components/message/GlobalMessage';
import { ThemeProvider, createTheme } from '@mui/material';
import { HoxRoot } from 'hox';

const lightTheme = createTheme({
  typography: {
    htmlFontSize: 18,
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#fafafa',
      paper: '#fff',
    },
  },
});

function App() {
  const element = useRoutes(routes);
  return (
    <div id='App'>
      <HoxRoot>
        <ThemeProvider theme={lightTheme}>
          <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
            <Suspense>{element}</Suspense>
            <GlobalMessage />
          </SnackbarProvider>
        </ThemeProvider>
      </HoxRoot>
    </div>
  );
}

export default App;
